module.exports = __webpack_public_path__ + "img/paw-simple.bc41ad76.svg";